/**
 * Key Metrics Cards for Accountant Report View
 * Displays Final Claim Amount, Variable Profit Loss, and Incremental Loss
 */

import React from 'react';

interface KeyMetricsProps {
  finalClaimAmount?: number;
  variableProfitLoss?: number;
  incrementalLoss?: number;
  causationPassed?: boolean;
  formatCurrency: (amount?: number) => string;
}

export default function AccountantKeyMetrics({
  finalClaimAmount,
  variableProfitLoss,
  incrementalLoss,
  causationPassed,
  formatCurrency
}: KeyMetricsProps) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
      <div className="bg-gradient-to-br from-green-500 to-green-600 rounded-xl p-6 text-white shadow-lg">
        <p className="text-sm opacity-90 mb-1">Final Claim Amount</p>
        <p className="text-4xl font-bold">{formatCurrency(finalClaimAmount)}</p>
        {causationPassed !== undefined && (
          <p className="text-sm mt-2 opacity-90">
            {causationPassed ? '✓ Causation Passed' : '✗ Causation Failed'}
          </p>
        )}
      </div>

      <div className="bg-gradient-to-br from-blue-500 to-blue-600 rounded-xl p-6 text-white shadow-lg">
        <p className="text-sm opacity-90 mb-1">Variable Profit Loss</p>
        <p className="text-4xl font-bold">{formatCurrency(variableProfitLoss)}</p>
        <p className="text-sm mt-2 opacity-90">Step 1 Calculation</p>
      </div>

      <div className="bg-gradient-to-br from-purple-500 to-purple-600 rounded-xl p-6 text-white shadow-lg">
        <p className="text-sm opacity-90 mb-1">Incremental Loss</p>
        <p className="text-4xl font-bold">{formatCurrency(incrementalLoss)}</p>
        <p className="text-sm mt-2 opacity-90">Step 2 Adjustment</p>
      </div>
    </div>
  );
}
